// Library methods

// Utils
import { POST } from '../../../../utils/fetchWrappers';
import kycResponse from 'components/KYCTab/kyc.res';

// API URLs
import {
    API_GET_MERCHANT_INFO,
    API_FETCH_PG_CONFIG,
    API_FETCH_ROUTER_DETAILS,
    API_FETCH_SURCHARGE_DETAILS,
    API_UPDATE_MERCHANT,
    API_UPDATE_PG_CONFIG,
    API_UPDATE_ROUTING,
    API_UPDATE_SURCHARGE,
    API_UPDATE_SECTIONS,
    API_FETCH_SECTIONS,
    API_HIERARCHY_LIST,
    API_UPDATE_SETTLEMENT,
    API_FETCH_BASIC_DATA,
    API_ADD_BD_ONBOARDING_MAKER, API_FETCH_AVAILABLE_BALANCE,
} from '../../../../utils/API/apiUrls';

// API Status Codes
import { apiStatusCodes } from '../../../../utils/API/apiStatusCodes';

// Helpers
import {
    getFormattedSectionData,
    getFlatSelectedData,
    getFormattedPGConfigOldData,
    shortFormatedData
} from '../../../../utils/helperMethods';
import { SECTION_LIST } from '../../../../utils/constants/commonValues';

// Redux Actions
import * as loaderActions from '../../../../redux/common/loader/loader.actions';
import * as editMerchantActions from './editMerchant.actions';

// Constants
import {
    GET_MERCHANT_INFO_REQUEST,
    FETCH_PG_CONFIG_EDIT_REQUEST,
    FETCH_ROUTER_DETAILS_REQUEST,
    FETCH_SURCHARGE_DETAILS_REQUEST,
    UPDATE_MERCHANT_DATA_REQUEST,
    UPDATE_PG_CONFIG_DATA_REQUEST,
    UPDATE_ROUTING_DATA_REQUEST,
    UPDATE_SURCHARGE_DATA_REQUEST,
    UPDATE_SECTION_DETAILS_REQUEST,
    GET_MERCHANT_SECTION_INFO_REQUEST,
    SET_SELECTED_ENTITY_REQUEST,
    UPDATE_SETTLEMENT_DATA_REQUEST,
    FETCH_BASIC_FORM_DATA,
    ADD_MERCHANT_STEP_UPDATE_MAKER_ERROR,
    ADD_MERCHANT_STEP_UPDATE_MAKER_REQUEST,
} from './editMerchant.constants';
import { takeLatest, put, call,  } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import API_FETCH_SURCHARGE_DETAILS_MOCK from "../API_FETCH_SURCHARGE_DETAILS.json"

export function* fetchMerchantInfoDetails(actions) {
    yield put(loaderActions.showLoader());
    const {history , toast } = actions;
    try {
        const { payload, fields } = actions;
        const request = {
            entityCode: payload,
            entityStatus: true,
        };

        const { data } = yield call(POST, API_GET_MERCHANT_INFO, request);

        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            const formattedData = getFormattedSectionData(data, fields);
            yield put(
                editMerchantActions.getMerchantInfoSuccess(formattedData)
            );
        } else if (data && data.errorMessage) {
            yield put(
                editMerchantActions.getMerchantInfoError({
                    error: data,
                })
            );
            history.push('/mob');
            toast.error(data.errorMessage);
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(editMerchantActions.getMerchantInfoError({ error: data }));
        history.push('/mob');
        toast.error("Merchant ID could not be found.");
    }
    yield put(loaderActions.hideLoader());
}

export function* fetchPGInfoDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload, fields } = actions;
        const request = {
            entityCode: payload,
        };
        const { data } = yield call(POST, API_FETCH_PG_CONFIG, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            const pgConfigurationDataResponse = getFormattedPGConfigOldData(
                data
            );

            const oldFormatData = {
                ...data,
                pgConfigurationDataResponse,
            };

            const formattedData = getFormattedSectionData(
                oldFormatData,
                fields,
                'pgConfigurationSection'
            );

            yield put(
                editMerchantActions.fetchPgConfigDetailsSuccess(formattedData)
            );
        } else if (data && data.errorMessage) {
            yield put(
                editMerchantActions.fetchPgConfigDetailsError({
                    error: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        yield put(
            editMerchantActions.fetchPgConfigDetailsError({
                error: response && response.data && response.data.errorMessage,
            })
        );
    }
    yield put(loaderActions.hideLoader());
}

export function* fetchRouterDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload, fields } = actions;
        const request = {
            entityCode: payload,
        };
        const { data } = yield call(POST, API_FETCH_ROUTER_DETAILS, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            const formattedData = getFormattedSectionData(
                data,
                fields,
                'dynamicRoutingSection'
            );
            yield put(
                editMerchantActions.fetchRouterDetailsSuccess(formattedData)
            );
        } else if (data && data.errorMessage) {
            yield put(
                editMerchantActions.fetchRouterDetailsError({
                    error: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        yield put(
            editMerchantActions.fetchRouterDetailsError({
                error: response && response.data && response.data.errorMessage,
            })
        );
    }
    yield put(loaderActions.hideLoader());
}




export function* fetchSurchargeDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload, fields } = actions;
        const request = {
            ...payload,
        };

        let data = {};

        if (process.env.REACT_APP_IS_ODS_MOCK === 'true') {
            data = API_FETCH_SURCHARGE_DETAILS_MOCK;
        } else {
            const res = yield call(POST, API_FETCH_SURCHARGE_DETAILS, request);
            data = res.data;
        }

        if (data && data.statusCode === apiStatusCodes.SUCCESS2) {
            const formattedData = getFormattedSectionData(
                data,
                fields,
                'surchargeSection'
            );
            const shortedData = shortFormatedData(formattedData);
            yield put(
                editMerchantActions.fetchSurchargeDetailsSuccess(shortedData)
            );
        } else if (data && data.errorMessage) {
            yield put(
                editMerchantActions.fetchSurchargeDetailsError({
                    error: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        yield put(
            editMerchantActions.fetchSurchargeDetailsError({
                error: response && response.data && response.data.errorMessage,
            })
        );
    }
    yield put(loaderActions.hideLoader());
}

export function* fetchBasicFormData(actions) {
    // console.log(actions,"consoling actionsssssss")
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const request = {
            ...payload,

        };
        // console.log("calling formData..... in case of kyc update");
        const { data } = yield call(POST, API_FETCH_BASIC_DATA, request);
        // const data = kycResponse(); // Hardcoded response
        console.log("Data from formData API response:", data);
        if (data && data.statusCode === apiStatusCodes.SUCCESS2) {
            yield put(editMerchantActions.fetchBasicFormSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                editMerchantActions.fetchBasicFormError({
                    error: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        yield put(
            editMerchantActions.fetchBasicFormError({
                error: response && response.data && response.data.errorMessage,
            })
        );
    }
    yield put(loaderActions.hideLoader());
}

export function* updateMerchantDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload, sectionType } = actions;
        const request = payload;
        const { data } = yield call(POST, API_UPDATE_MERCHANT, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                editMerchantActions.updateMerchantDataSuccess(data, sectionType)
            );
        } else if (data && data.errorMessage) {
            yield put(
                editMerchantActions.updateMerchantDataError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const data = response && response.data;
        yield put(editMerchantActions.updateMerchantDataError({ error: data }));
    }
    yield put(loaderActions.hideLoader());
}

export function* updatePGInfoDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload, sectionType } = actions;
        const request = payload;

        const { data } = yield call(POST, API_UPDATE_PG_CONFIG, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                editMerchantActions.updatePgConfigDataSuccess(data, sectionType)
            );
        } else if (data && data.errorMessage) {
            yield put(
                editMerchantActions.updatePgConfigDataError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const data = response && response.data;
        yield put(editMerchantActions.updatePgConfigDataError({ error: data }));
    }
    yield put(loaderActions.hideLoader());
}

export function* updateSettlementDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload, sectionType} = actions;
        // console.log("payloadddddd" , payload);
        const request = payload;
       //console.log("request of updateSellementdata " ,request);
        const { data } = yield call(POST, API_UPDATE_SETTLEMENT, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS2) {
            yield put(
                editMerchantActions.updateSettlementDataSuccess(
                    data,
                    sectionType
                )
            );
        } else if (data && data.errorMessage) {
            yield put(
                editMerchantActions.updateSettlementDataError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const data = response && response.data;
        yield put(
            editMerchantActions.updateSettlementDataError({ error: data })
        );
    }
    yield put(loaderActions.hideLoader());
}

export function* updateRoutingDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload, sectionType } = actions;
        const request = payload;
        const { data } = yield call(POST, API_UPDATE_ROUTING, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                editMerchantActions.updateRoutingDataSuccess(data, sectionType)
            );
        } else if (data && data.errorMessage) {
            yield put(
                editMerchantActions.updateRoutingDataError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const data = response && response.data;
        yield put(editMerchantActions.updateRoutingDataError({ error: data }));
    }
    yield put(loaderActions.hideLoader());
}

export function* updateSurchargeDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload, sectionType } = actions;
        const request = payload;
        const { data } = yield call(POST, API_UPDATE_SURCHARGE, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS2) {
            yield put(
                editMerchantActions.updateSurchargeDataSuccess(
                    data,
                    sectionType
                )
            );
        } else if (data && data.errorMessage) {
            yield put(
                editMerchantActions.updateSurchargeDataError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const data = response && response.data;
        yield put(
            editMerchantActions.updateSurchargeDataError({ error: data })
        );
    }
    yield put(loaderActions.hideLoader());
}

export function* updateSectionsDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload, sectionType } = actions;
        const { data } = yield call(POST, API_UPDATE_SECTIONS, payload);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                editMerchantActions.updateSectionDataSuccess(data, sectionType)
            );
        } else if (data && data.errorMessage) {
            yield put(
                editMerchantActions.updateSectionDataError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const data = response && response.data;
        yield put(editMerchantActions.updateSectionDataError({ error: data }));
    }
    yield put(loaderActions.hideLoader());
}

export function* fetchSectionDetails(actions) {

    yield put(loaderActions.showLoader());
    const { payload, fields, sectionType, history } = actions;
    try {
        const request = {
            entityCode: payload,
            configurationType: SECTION_LIST[sectionType],
        };
        const { data } = yield call(POST, API_FETCH_SECTIONS, request);
        //console.log(data ,"consoling data");
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            const formattedData = getFormattedSectionData(
                data,
                fields,
                sectionType,
            );
            //console.log(formattedData,"consoling formatted data");
            yield put(
                editMerchantActions.getMerchantSectionInfoSuccess(formattedData)
            );
        } else if (data && data.errorMessage) {
            yield put(
                editMerchantActions.getMerchantSectionInfoError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        console.log("🚀 ~ function*fetchSectionDetails ~ response:", response.data)
        const { data } = response;
        yield put(
            editMerchantActions.getMerchantSectionInfoError({ error: data })
        );
        if(response.data.statusCode == 'SPGM-0002' || response.data.statusCode == "ER-7100"){
            toast.error("Merchant ID could not be found.");
            if(!!history){
                history.push('/mob');
            }
        }
    }
    yield put(loaderActions.hideLoader());
}

const getEntityLevel = entityType => {
    return 'UPPER_COMPLETE';
};

export function* setSelectedEntityDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload, entityType } = actions;
        const request = {
            entityCode: payload,
            entityLevel: getEntityLevel(entityType),
        };

        const { data } = yield call(POST, API_HIERARCHY_LIST, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            const formattedData = getFlatSelectedData(
                data,
                entityType,
                payload
            );
            yield put(editMerchantActions.setEntityDataSuccess(formattedData));
        } else if (data && data.errorMessage) {
            yield put(
                editMerchantActions.setEntityDataError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(editMerchantActions.setEntityDataError({ error: data }));
    }
    yield put(loaderActions.hideLoader());
}

export function* addSectionMakerRequest(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload, sectionType, makerDetails ,customisedReports } = actions;
        // console.log("consoling actionssss" ,actions);
        //console.log('customisedReports',customisedReports);
        const modifiedPayload = {...payload,customisedReports};

        const makerRequest = {
            ...makerDetails,
            request: JSON.stringify(modifiedPayload),
        };
        console.log("makerRequest", makerRequest);
        const { data } = yield call(
            POST,
            API_ADD_BD_ONBOARDING_MAKER('merchant'),
            makerRequest
        );
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                editMerchantActions.addMerchantStepUpdateMakerSuccess(
                    data,
                    sectionType
                )
            );
        } else if (data && data.errorMessage) {
            if(toast){
                toast.error(data.errorMessage);
            }
        }
    } catch ({ response }) {
        const data = response && response.data;
        toast.error(data.errorMessage);
    }
    yield put(loaderActions.hideLoader());
}

/**
 * WATCHER SAGA
 */
export function* editMerchantSagas() {
    yield takeLatest(GET_MERCHANT_INFO_REQUEST,fetchMerchantInfoDetails);
    yield takeLatest(FETCH_PG_CONFIG_EDIT_REQUEST, fetchPGInfoDetails);
    yield takeLatest(FETCH_ROUTER_DETAILS_REQUEST, fetchRouterDetails);
    yield takeLatest(FETCH_SURCHARGE_DETAILS_REQUEST, fetchSurchargeDetails);
    yield takeLatest(FETCH_BASIC_FORM_DATA, fetchBasicFormData);
    yield takeLatest(UPDATE_MERCHANT_DATA_REQUEST, updateMerchantDetails);
    yield takeLatest(UPDATE_PG_CONFIG_DATA_REQUEST, updatePGInfoDetails);
    yield takeLatest(UPDATE_ROUTING_DATA_REQUEST, updateRoutingDetails);
    yield takeLatest(UPDATE_SURCHARGE_DATA_REQUEST, updateSurchargeDetails);
    yield takeLatest(UPDATE_SECTION_DETAILS_REQUEST, updateSectionsDetails);
    yield takeLatest(GET_MERCHANT_SECTION_INFO_REQUEST, fetchSectionDetails);
    yield takeLatest(SET_SELECTED_ENTITY_REQUEST, setSelectedEntityDetails);
    yield takeLatest(UPDATE_SETTLEMENT_DATA_REQUEST, updateSettlementDetails);
    yield takeLatest(
        ADD_MERCHANT_STEP_UPDATE_MAKER_REQUEST,
        addSectionMakerRequest
    );
}
